/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
import { Property } from 'csstype';
import { Text } from '../UNSAFE_Text';
import { taskLabelLayerStyles } from './themes/GanttStyles.css';
import { classNames } from '../utils/UNSAFE_classNames';

type Props = {
  x: number;
  y: number;
  width: number;
  height: number;
  label: string;
  isInner: boolean;
  textAlign: 'left' | 'center' | 'right';
  labelStyle?: {
    color?: Property.Color;
    fontFamily?: Property.FontFamily;
    fontSize?: Property.FontSize;
    fontStyle?: Property.FontStyle;
    fontWeight?: Property.FontWeight;
    textDecoration?: Property.TextDecoration;
  };
};

export function GanttTaskLabel({
  x,
  y,
  width,
  height,
  label,
  isInner,
  textAlign,
  labelStyle
}: Props) {
  return (
    <div
      aria-hidden="true"
      class={classNames([taskLabelLayerStyles.label, isInner && taskLabelLayerStyles.innerLabel])}
      style={{
        left: x,
        top: y,
        width,
        height,
        textAlign,
        ...labelStyle
      }}>
      <Text
        variant={labelStyle?.color ? 'inherit' : 'primary'}
        truncation="ellipsis"
        size="md"
        weight="inherit">
        {label}
      </Text>
    </div>
  );
}
